import { appConfig } from 'brand-config';

import { isEnvScopedFlagEnabled } from 'core/helpers/env-scoped-flag';
import { isCondensedLayout } from 'core/components/theme/condensed-layout';

/**
 * Staff Quote Revisit (#32313): when on, Modify Quote and Checkout render the new modules in
 * src/quote-revisit/ instead of today's header, left column, tab list and footer. The pages pick
 * between the two at a handful of swap points (#36353); today's components get no brand branches.
 */
export const isQuoteRevisitEnabled = () => isEnvScopedFlagEnabled(appConfig?.featureFlags?.quoteRevisit);

// The condensed layout's Modify Quote: a step rail replaces the tab row and the side column moves right.
export const isQuoteStepRailEnabled = () => isQuoteRevisitEnabled() && isCondensedLayout();
